import { AnyAction } from '@reduxjs/toolkit'

import {
  NOTIFICATION_ADD,
  NOTIFICATION_CLEAR_ALL,
  NOTIFICATION_REMOVE,
  NOTIFICATION_UPDATE
} from './notifications-constants'
import type { NotificationType } from './types'

type NotificationState = {
  notifications: NotificationType[]
}
const initState: NotificationState = { notifications: [] }

const notificationReducer = (state = initState, action: AnyAction) => {
  switch(action.type) {
    case NOTIFICATION_ADD:
      return { ...state, notifications: state.notifications.concat(action.notification) }
    case NOTIFICATION_UPDATE:
      return {
        ...state,
        notifications:
          state.notifications.map(n => n.name === action.name ? { ...n, body: action.body } : n)
      }
    case NOTIFICATION_REMOVE:
      return { ...state, notifications: state.notifications.filter(n => n.name !== action.name) }
    case NOTIFICATION_CLEAR_ALL:
      return { ...state, notifications: [] }
    default:
      return state
  }
}

export {
  notificationReducer
}

export type {
  NotificationState
}
